import { AspectRatio, Box, Flex, HStack, Text } from '@chakra-ui/react'
import Image from 'next/image'
import { MainContainer } from './index'
import Link from 'next/link'

const Hero = () => {
  return (
    <Box
      data-aos="fade-up"
      w="100%"
      bgColor="transparent"
      position="relative"
      pb={{
        base: 0,
        sm: '200px',
        md: '300px',
        lg: '300px',
        xl: 0
      }}
      minH={{
        base: 'unset',
        xl: 1280
      }}
    >
      <MainContainer
        mt={{
          base: '43px',
          lg: '43px'
        }}
        data-aos="fade-up"
      >
        <Flex
          gap={{
            base: 2,
            lg: 10
          }}
          flexDir={{
            base: 'column',
            lg: 'row'
          }}
          minH={880}
        >
          <Box maxW={760}>
            <Flex
              w="100%"
              justifyContent={{
                base: 'center',
                lg: 'flex-start'
              }}
              alignItems="center"
              flexDir="row"
            >
              <AspectRatio
                w={{
                  base: '300px',
                  sm: '400px',
                  md: '500px',
                  xl: '530px'
                }}
                ratio={3508 / 1630}
                ml={{
                  base: '0px',
                  lg: '-50px',
                  xl: '-50px'
                }}
              >
                <Image
                  src={
                    'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/health-care-1714038035206.png'
                  }
                  alt="health care"
                  fill
                />
              </AspectRatio>
            </Flex>
            <Text
              textStyle="supplementHeroTitle"
              textTransform="uppercase"
              textAlign={{
                base: 'center',
                md: 'left'
              }}
              w="100%"
              zIndex={100}
              color={'#9cb259'}
            >
              STAY HEALTHY, THE HAPPY WAY
            </Text>

            <Text
              textStyle="supplementHeroSubTitle"
              textTransform="uppercase"
              textAlign={{
                base: 'center',
                lg: 'left'
              }}
              w={{
                base: '100%',
                lg: '80%'
              }}
              zIndex={100}
              color={'#404040'}
            >
              あなたのウェルネスの旅を私たちと一緒に始めましょう。
            </Text>

            <HStack
              justifyContent={{
                base: 'center',
                lg: 'flex-start'
              }}
              mt={{
                base: '20px',
                md: '40px'
              }}
            >
              <AspectRatio
                ratio={1}
                w={{
                  base: '120px',
                  sm: '120px',
                  md: '140px',
                  lg: '160px',
                  xl: '160px'
                }}
                _hover={{
                  opacity: 0.7
                }}
                mt={3}
              >
                <Image
                  src={
                    'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/Health%2B%20Japanese%20Kampo%20Supplement%20%EF%BF%BD%2Cn%22%EF%BF%BD%20Microsite-1732010300473.png'
                  }
                  alt="health plus"
                  fill
                />
              </AspectRatio>
            </HStack>
          </Box>

          <Flex
            w={{
              base: '100%',
              lg: '43%'
            }}
            ml={{
              base: '0px',
              md: '0px',
              lg: '-60px',
              xl: '-60px'
            }}
            h={'100%'}
            mt={{
              base: 'unset',
              lg: 'auto'
            }}
            flexDir="column"
            justifyContent="center"
            alignItems="center"
          >
            <AspectRatio
              ratio={956 / 798}
              w={{
                base: '100%',
                md: '600px',
                lg: '900px',
                xl: '956px'
              }}
            >
              <Image
                src={
                  'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/mother-child-1730873990221.png'
                }
                alt="mom and child"
                className="object-cover object-left"
                fill
              />
            </AspectRatio>
          </Flex>
        </Flex>
      </MainContainer>

      <Box
        w="100%"
        bgColor="transparent"
        position="absolute"
        bottom={{
          base: 10,
          md: 10,
          lg: 20
        }}
        left={0}
        mt={-10}
        zIndex={10}
      >
        <MainContainer
          mt={{
            base: '0px',
            lg: '0px'
          }}
        >
          <Flex
            width={'100%'}
            justifyContent={{
              base: 'center',
              lg: 'flex-end'
            }}
            pl={-10}
          >
            <AspectRatio
              ratio={487 / 320}
              w={{
                base: '90%',
                md: '80%',
                lg: '750px',
                xl: '900px'
              }}
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/hero-1738815783654.png"
                alt="items hero"
                fill
                className="object-cover object-right"
              />
            </AspectRatio>
          </Flex>
        </MainContainer>
      </Box>

      <Box width={'100%'} mb="-40px" position={'absolute'} bottom={0} left={0}>
        <AspectRatio ratio={683 / 298} w="100%">
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bg-hero-bot-transparent-1730873290043.png"
            alt="bg hero bot"
            fill
            className="object-cover object-right"
          />
        </AspectRatio>
      </Box>

      <Box
        position={'absolute'}
        bottom={{
          base: -2,
          md: 0,
          lg: 5
        }}
        left={5}
        right={5}
        zIndex={11}
      >
        <Flex justifyContent="space-between" alignItems="center">
          <AspectRatio
            ratio={110 / 110}
            w={{
              base: '80px',
              xl: '110px'
            }}
            position="relative"
          >
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/brand-sin-1730877205286.png"
              alt="brand sin"
              fill
              className="object-cover"
            />
          </AspectRatio>

          <Box
            w={{
              base: '160px',
              xl: '220px'
            }}
          >
            <AspectRatio ratio={220 / 47} w={'100%'}>
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/habbit-jml-1730877205287.png"
                alt="habbit jml logo"
                fill
                className="object-contain"
              />
            </AspectRatio>
          </Box>
        </Flex>
      </Box>
    </Box>
  )
}

export default Hero
